// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"796163b7","303":"839c3a1c","305":"8136b916","787":"0ede400a","886":"76cdcbd8","970":"fc93c02c"}[chunkId] + ".chunk.js";
};